import moment from 'moment'

export const formatDate = (dateStr?: string): string => {
  if (!dateStr) return '--'
  return moment(dateStr).format('MMM D, YYYY, HH:mm:ss')
}

/**
 * Formats an ISO date (the backend sends UTC, e.g. "2026-07-21T12:00:00Z") into a
 * timezone-unambiguous label, e.g. "21 Jul 2026 at 12:00 UTC".
 */
export const formatDateAtTime = (dateStr: string): string => moment.utc(dateStr).format('D MMM YYYY [at] HH:mm [UTC]')

/**
 * Viewer-local activity timestamp: DD MMM YYYY, HH:mm. Seconds and UTC suffix are omitted
 * so the feed matches LP-117872 S07 without using formatDateAtTime (UTC).
 */
export const formatLocalDateTime = (dateStr?: string): string => {
  if (!dateStr) return '--'
  return moment(dateStr).format('DD MMM YYYY, HH:mm')
}
